<template>
    <div class="d-flex flex-nowrap">
        <strong style="white-space: nowrap; color: rgb(208, 49, 49)" class="mr-auto p-2">Current Year: &nbsp</strong>
        <select class="form-control" name="current_year"
                style="font-size: 16px; font-weight: bolder; color: rgb(208, 49, 49); !important; width: 200px;"
                v-model="current_year">
            <option style=" color: rgb(208, 49, 49); !important;" :value="n" v-for="n in years">{{ n }}</option>
        </select>

        <slot v-if="showTerm">
            <strong style="white-space: nowrap; color: rgb(208, 49, 49)" class="mr-auto p-2">Contract Term:
                &nbsp</strong>
            <span style="width: 200px; margin-top: 8px;">{{
                    $store.getters['generic/getStartDate'] | dateUs
                }} - {{ $store.getters['generic/getEndDate'] | dateUs }}</span>
        </slot>
        <slot v-else>
            <strong style="white-space: nowrap; color: rgb(208, 49, 49)" class="mr-auto p-2">
                &nbsp</strong>
            <span style="width: 400px; margin-top: 8px;">&nbsp;</span>
        </slot>

    </div>
</template>

<script>
export default {
    name: "CurrentYear",
    props: {

        terms: {
            default() {
                return []
            }
        },
        current: {
            default: null
        },
        showTerm: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            current_term: null,
            current_year: null,
            years: [],
            origin: Math.random()
        }
    },
    watch: {
        current_year(val) {
            this.$store.commit('generic/setCurrentYear', val)
        },
        current_term(val) {
            let year = val.substring(6, 10)
            this.$store.commit('generic/setCurrentYear', year)
        },
        '$store.state.generic.currentYear'(val) {
            if (val !== this.current_year) {
                this.current_year = parseInt(val)
            } else {
                this.setCurrentYear()
            }

        }
    },
    methods: {
        async setCurrentYear() {
            await axios.post('/current-year', {
                current_year: this.current_year
            })
        }
    },
    mounted() {
        if (this.current) {
            this.current_year = parseInt(this.current)
        } else {
            this.current_year = this.$moment().format('Y')
        }
        for (let i = -7; i < 5; i++) {
            this.years.push(this.$moment().add(i, 'year').format('Y'))
        }
    }
}
</script>

<style scoped>

.form-control {
    font-size: 12px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 0 0.25em !important;
    background-color: #fff !important;
    border-radius: 1px !important;
    color: rgb(208, 49, 49) !important;
    height: 25px;
    border: 1px solid rgba(60, 60, 60, .26) !important;
}
</style>
